module.exports = __webpack_public_path__ + "img/w18-qr.e3fd8f2e.jpg";